import storage from '@/utils/storage'

/** Returns `true` if Mercury should be used instead of Avetti. */
export const useMercury = (): boolean => !!storage.getItem('useMercury')
